$basefont: 16;

@function rem($pxWidth) {
	$calculated: $pxWidth / $basefont;
	@return $calculated + rem;
}
